export default __webpack_public_path__ + "static/remix-ae3da38d0c8a8e16da81b11c7c44ab2d.svg";